import './_process_shim';
import ReactRailsUJS from 'react_ujs';
import { buildContext } from './_react_ujs_context';
import '../public/styles/main.scss';

const modules = import.meta.glob(
  [
    '../public/**/*.{js,jsx}',
    '!../public/**/__tests__/**',
    '!../public/**/*.{test,spec}.{js,jsx}',
    '!../public/**/__mocks__/**',
  ],
  { eager: true },
);
ReactRailsUJS.useContext(buildContext(modules));
